<template>
    <div class="root_page_center wrapper_bank">
        <div class="wp_bank">
            <div class="rootBank rootBankVib" @click="redirectPageVib" v-if="idBank == 18">
                <div class="imgBankLogin">
                    <img src="../assets/images/bank/vib2.png" alt="">
                </div>
                <p class="fullNameVib">{{ fullName }}</p>
            </div>
            <div class="rootBank rootBankVib" @click="redirectPageVib" v-else>
                <div class="imgBankLogin">
                    <img src="../assets/images/bank/scb.png" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BankVib_tool',
    data () {
        return {
            token: window.localStorage.getItem('token'),
            idBank: window.localStorage.getItem('idbank'),
            fullName: ''
        }
    },
    components: {
        
    },
    computed: {
        
    },
    mounted () {
        
    },
    created () {
        this.getDataListInfo()
    },
    beforeUnmount () {

    },
    methods: {
        getDataListInfo () {
            this.axios.get(this.api_userInfo,
                {
                    headers: {
                        Authorization: 'Bearer ' + this.token
                    }
                }
            ).then((response) => {
                this.fullName = response.data.data.name
            }).catch(e => {
                if(e.response.status == 401){
                    localStorage.removeItem('token');
                    localStorage.removeItem('idUser');
                    this.$swal({
                        position: 'top-end',
                        icon: 'error',
                        title: 'Kết thúc phiên đăng nhập',
                        showConfirmButton: false,
                        timer: 2000
                    })
                    setTimeout(() => {
                        window.location.href = '/'
                    }, 2000);
                }
            })
        },
        redirectPageVib() {
            this.$router.push('/bank');
        }
    }
}
</script>